import { InjectionToken } from '@angular/core';

export interface IdentityProvider<T> {
  manages(token: string): boolean;
  validate(token: string, value: unknown): void;
  modifyIdentity(
    identities: IdentityPayload[],
    token: string,
    value: unknown,
  ): void;
  getValueFromIdentities(identities: IdentityPayload[], token: string): any;
}

export const IDENTITY_PROVIDER = new InjectionToken<
  IdentityProvider<unknown>[]
>('Identity Service');

export interface IdentityCarrier {
  identities: IdentityPayload[];
}

export interface IdentityPayload<T extends any = unknown> {
  type: string;
  payload: T;
}

export interface IdentityCarrier {
  identities: IdentityPayload[];
}
